import pqLogoRedWhite from '@/assets/pq_logo_red_white.png';
import { Group, Image, Text } from "@mantine/core";
import Search from '@/components/Search';
import SideNav from './components/SideNav';

const TopNav: React.FC = () => {

    return (
        <Group h="100%" px="md" bg="black" justify='space-between' >
            <SideNav />            
            {import.meta.env.MODE === 'staging' ? <Text c='pq-red' size='xl'>PQ Mobile Staging</Text> : <Image src={pqLogoRedWhite} alt="ParcelQuest Logo" height={40} />}
            <Search />
        </Group>
    );
}

export default TopNav;